/** Завантаження файлу запису через DAO із заголовками авторизації та збереження в браузері під його іменем. */
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiError, dao } from '@platform/dao';
import type { IApiErrorPlain, IAttachment } from '@platform/core/types';
import { saveFile } from '../list/saveFile';

/**
 * Файл вкладки «Файли»: fetch DAO з тими самими заголовками, що й решта запитів (X-Dev-User у Development, Bearer у продуктиві), а не просте
 * посилання `<a href>` без них; зберігається з іменем із Content-Disposition або вкладення. `busyId` — файл, що завантажується (повторний клік
 * не діє); `error` — повідомлення про невдачу з іменем файлу (ErrorBanner), скидається наступною спробою.
 */
export function useFileDownload() {
  const { t } = useTranslation();
  const [busyId, setBusyId] = useState<string | null>(null);
  const [error, setError] = useState<IApiErrorPlain | null>(null);
  const download = useCallback(async (file: IAttachment) => {
    setBusyId(file.id);
    setError(null);
    try {
      const result = await dao.collaboration.download(file.id, file.fileName);
      saveFile(result.blob, result.fileName);
    } catch (e) {
      const problem = ApiError.fromUnknown(e);
      setError({ ...problem, message: t('tabs.downloadFailed', { name: file.fileName, message: problem.message }) });
    } finally {
      setBusyId(null);
    }
  }, [t]);
  return { busyId, error, download };
}
